import React, { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import Post from "../feed/Post";
import PostSkeleton from "../feed/PostSkeleton";

//Actions
import { getPostData } from "../../actions/feed";

//Selectors
import { getPostDataFromCache } from "../../selectors/postSelectors";

const ProfilePostManager = ({
  index,
  getPostData,
  feed,
  viewedProfile: { posts },
  viewedLoading,
  fullWidth = false,
}) => {
  const requestedRef = useRef(false);

  const basePost = posts.posts[index];
  const postId = basePost?.postid;
  const repostUserId = basePost?.repostuser || null;

  const cachedData = postId ? getPostDataFromCache(feed, postId, repostUserId) : null;
  const errorCooldownTs = feed?.postCache?.errors?.[postId];
  const inCooldown = errorCooldownTs && errorCooldownTs > Date.now();

  useEffect(() => {
    requestedRef.current = false;
  }, [postId, repostUserId]);

  useEffect(() => {
    if (!postId || viewedLoading) return;
    if (!cachedData && !inCooldown && !requestedRef.current) {
      requestedRef.current = true;
      // Use -1 to populate cache without mutating profile feed list items
      getPostData(postId, -1, repostUserId);
    }
  }, [cachedData, inCooldown, getPostData, postId, repostUserId, viewedLoading]);

  const shouldShowSkeleton = !cachedData && !inCooldown;
  const hasError = !cachedData && inCooldown;

  const composedPost = cachedData
    ? {
        ...basePost,
        loading: false,
        error: false,
        postData: cachedData,
      }
    : basePost;

  return (
    <div className="md:mt-2">
      {hasError ? null : shouldShowSkeleton ? <PostSkeleton /> : <Post post={composedPost} fullWidth={fullWidth} />}
    </div>
  );
};

ProfilePostManager.propTypes = {
  getPostData: PropTypes.func.isRequired,
  feed: PropTypes.object.isRequired,
  viewedProfile: PropTypes.object.isRequired,
  viewedLoading: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => ({
  feed: state.feed,
  viewedProfile: state.profile.viewedProfile,
  viewedLoading: state.profile.viewedLoading,
});
export default connect(mapStateToProps, { getPostData })(ProfilePostManager);
